module.exports = __webpack_public_path__ + "dd7ed0afadacbec6303d6c412a360bc2.png";